import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Task, TaskLink } from './tasks.service';

/** What a caller may pre-fill when opening the "New task" window from anywhere in Link. */
export interface TaskPrefill {
  title?: string;
  details?: string;
  assigneeId?: string;
  department?: string;
  dueDate?: string | null;
  priority?: 'normal' | 'high';
  /** Catalogue id (e.g. 'follow_up'); otherwise tagged from the title. */
  type?: string;
  link?: TaskLink | null;
  source?: string;
  sourceRef?: Record<string, any>;
  parentTaskId?: string;
  parentTitle?: string;
}

/**
 * One "New task" window for the whole app (rendered once in AppComponent).
 * Header button, chat messages, project pages and the Tasks page all call
 * `open()`; whoever cares listens to `created$`.
 */
@Injectable({ providedIn: 'root' })
export class TaskComposerService {
  readonly open$ = new Subject<TaskPrefill>();
  readonly created$ = new Subject<Task>();

  open(prefill: TaskPrefill = {}) {
    this.open$.next(prefill);
  }
}
